import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

const Spinner = (props: any) => {
    if (props.type === '01') {
        return (
            <div className="spinner-01">
                <CircularProgress size={75} />
            </div>
        );
    }
    if (props.type === '02') {
        return (
            <div className="spinner-02">
                <CircularProgress size={50} />
            </div>
        );
    }

    return (
        <div className="spinner-00">
            <CircularProgress />
        </div>
    );
};

export default Spinner;
